export const sortHeaderStyle = {
  color: "#9e9e9e",
  fontWeight: 500,
  fontSize: "14px",
  paddingBottom: "1rem",
  whiteSpace: "nowrap",
  textAlign: "left"
};
